import reportService from '@/services/report.service';
import pbiService from '@/services/pbi.service';
import commonService from '@/services/common.service';
import config from '@/config/prod.env';

const actions = {

    async getAllPagingReport({ dispatch }, params) {
        return await reportService.getAllPaging(params);
    },

    async getReportByWorkspaceIdPaging({ dispatch }, obj) {
        return await reportService.getByWorkspaceIdPaging(obj.params, obj.workspaceId);
    },

    async getActiveReportByWorkspaceId({ dispatch }, workspaceId) {
        return await reportService.getByWorkspaceId(workspaceId, true);
    },

    async getReportById({ dispatch }, id) {
        return await reportService.getById(id);
    },

    async getPBIReports({ dispatch }, workspaceId) {
        return await pbiService.getReports(workspaceId);
    },
    
    async createReport({ dispatch, commit }, report) {
        // upload image
        let uploadImageRes = null;
        if(report.localImage) {
            uploadImageRes = await commonService.uploadFile(report.localImage);
            report.imageUrl = uploadImageRes.data.data;
        }

        let res = await reportService.create(report);
        if(res.isOk) {
            if(res.data && res.data.data.id) {
                dispatch("alert/success", "Thêm mới thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async updateReport({ dispatch, commit }, report) {
        let uploadImageRes = null;
        if(report.isChangedImage) {
            // remove old image
            await commonService.deleteFile(report.imageUrl);

            if(report.localImage === null) {
                report.imageUrl = "";
            } else {
                uploadImageRes = await commonService.uploadFile(report.localImage);
                report.imageUrl = uploadImageRes.data.data;
            }
        }

        let res = await reportService.update(report);
        if(res.isOk) {
            if(res.data.data) {
                dispatch("alert/success", "Cập nhật thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async updateReportStatus({ dispatch, commit }, obj) {
        let res = await reportService.updateStatus(obj.id, obj.status);
        if(res.isOk) {
            if(res.data.data) {
                dispatch("alert/success", "Cập nhật thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteReport({ dispatch, commit }, id) {
        let res = await reportService.delete(id);
        if(res.isOk) {
            if(res.data.data) {
                dispatch("alert/success", "Xóa thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteManyReport({ dispatch, commit }, ids) {
        let res = await reportService.deleteMany(ids);
        if(res.isOk) {
            if(res.data.data) {
                dispatch("alert/success", `Đã xóa ${res.data.data} dòng`, { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

};

export const report = {
    namespaced: true,
    actions
};